import { PERMISSION } from '@/constants/permission.constant';

const list = () => import('@/views/customer-review/List.vue');
const edit = () => import('@/views/customer-review/Edit.vue');
const create = () => import('@/views/customer-review/Create.vue');
const customerList = () => import('@/views/customer-review/CustomerList.vue');

export const custReviewRoute = [
  {
    path: 'customer-review',
    name: 'customer-review-list',
    component: list,
    meta: { requiresAuth: false, permissions: [PERMISSION.CUSTOMER_REVIEW_READ] },
  },
  {
    path: 'customer-review/create',
    name: 'customer-review-create',
    component: create,
    meta: { requiresAuth: false, permissions: [PERMISSION.CUSTOMER_REVIEW_CREATE] },
  },

  {
    path: 'customer-review/:id/edit',
    name: 'customer-review-update',
    component: edit,
    meta: { requiresAuth: false, permissions: [PERMISSION.CUSTOMER_REVIEW_UPDATE] },
  },

  {
    path: 'customers',
    name: 'customers',
    component: customerList,
    meta: { requiresAuth: false, permissions: [PERMISSION.CUSTOMER_READ] },
  },
];
